<template>
  <div class="rights-box">
    <div class="rights-list">
      <div class="rights-item rights-1" v-for="(item, index) in imgList" :key="index">
        <img class="img" :src="item.imgUrl"/>
        <div class="rights-btn" @click="handlePop">
          <img class="img" :src="item.btnUrl"/>
        </div>
      </div>
    </div>
    <van-popup class="custom-popup" v-model="showResult" round>
      <div class="result-box">
        <h3 class="title">提示</h3>
        <h3 class="desc">APP版本较低，请升级最新版本参与活动</h3>
        <div class="desc txt">升级路径：在”我的“模块点击右上角设置按钮-版本更新即可自动下载最新版APP</div>
        <div class="btn-box">
          <button class="btn btn-block" @click="handleCancel">确定</button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Popup } from 'vant'
export default {
  components: {
    [Popup.name]: Popup
  },
  data () {
    return {
      showResult: false,
      imgList: [
        {
          imgUrl: 'https://oss.aqdpay.com/appweb/qdtRights/rights11.png',
          btnUrl: 'https://oss.aqdpay.com/appweb/qdtRights/rightsbtn11.png'
        },
        {
          imgUrl: 'https://oss.aqdpay.com/appweb/qdtRights/rights12.png',
          btnUrl: 'https://oss.aqdpay.com/appweb/qdtRights/rightsbtn12.png'
        },
        {
          imgUrl: 'https://oss.aqdpay.com/appweb/qdtRights/rights21.png',
          btnUrl: 'https://oss.aqdpay.com/appweb/qdtRights/rightsbtn21.png'
        },
        {
          imgUrl: 'https://oss.aqdpay.com/appweb/qdtRights/rights22.png',
          btnUrl: 'https://oss.aqdpay.com/appweb/qdtRights/rightsbtn22.png'
        }
      ]
    }
  },
  methods: {
    handlePop () {
      this.showResult = true
    },
    handleCancel () {
      this.showResult = false
    }
  }
}
</script>
<style lang='scss' scoped>
.rights-box {
  background: url('https://oss.aqdpay.com/appweb/qdtRights/rightsbg.png') no-repeat left top;
  background-size: 100%;
  padding-top: 250px;
  padding-bottom: 30px;
}
.rights-bg {
  .img {
    width: 100%;
  }
}
.rights-list {
  padding: 15px 15px 15px 15px;
}
.rights-item {
  position: relative;
  margin-bottom: 15px;
  .img {
    width: 100%;
  }
}
.rights-btn {
  position: absolute;
  bottom: 7px;
  margin: 5px 20px;
  .img {
    width: 100%;
  }
}
.custom-popup {
  width: 80%;
  padding: 20px 18px 12px;
  border-radius: 8px;
  font-size: 15px;
  color: #333;
}
.result-box {
  .title {
    font-size: 18px;
    text-align: center;
    margin-bottom: 15px;
  }
  .desc {
    font-size: 15px;
    margin-bottom: 12px;
  }
  .txt {
    color: #666;
  }
}
.btn-box {
  display: flex;
  justify-content: center;
  .btn {
    width: 110px;
    margin: 40px 10px 10px;
    padding: 10px;
    border: none;
    outline: none;
    color: #fff;
    font-size: 15px;
    border-radius: 30px;
    background: #484140;
  }
  .btn-cancel {
    background: #F6F8FA;
    color: #B4C0CB;
  }
  .btn-block {
    width: 90%;
  }
}
</style>
